import React from 'react';

class YouTube extends React.Component {
    render() {
        let { src, key, className } = this.props;
        return (
          <div
            key={key}
            className={className} >
            <iframe
              allow="autoplay"
              encrypted-media="true"
              gyroscope="true"
              picture-in-picture="true"
              className={className}
              src={src}
              frameBorder="0"
              allowFullScreen={true}>
            </iframe>
          </div>
        );
    }
}

export default YouTube;
